import { render, staticRenderFns } from "./CompositeRights.vue?vue&type=template&id=52260af4"
import script from "./CompositeRights.vue?vue&type=script&lang=js"
export * from "./CompositeRights.vue?vue&type=script&lang=js"
import style0 from "./CompositeRights.vue?vue&type=style&index=0&id=52260af4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports